'use client';

import React, { useEffect } from 'react';
import Link from 'next/link';
import { RefreshCw, Compass } from 'lucide-react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-12 px-4 sm:px-6">
      <div className="w-full max-w-lg text-center space-y-6">
        <div className="font-['Lexend'] text-7xl sm:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white/40 to-white/10 select-none tracking-widest">
          500
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl font-['Lexend'] font-semibold text-white tracking-tight">
            Something Went Wrong
          </h1>
          <p className="text-sm text-[rgba(220,236,255,0.75)] max-w-md mx-auto leading-relaxed">
            An unexpected error occurred during celestial computation. Please try again.
          </p>
        </div>
        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => reset()}
            className="w-full sm:w-auto h-11 px-6 rounded-full bg-white hover:bg-[#e6edff] text-[#050a24] font-semibold text-sm shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer"
          >
            <RefreshCw className="w-4 h-4 text-[#050a24]" />
            <span>Try Again</span>
          </button>
          <Link href="/all-calculators" className="w-full sm:w-auto">
            <button
              type="button"
              className="w-full sm:w-auto h-11 px-6 rounded-full bg-white/[0.08] hover:bg-white/[0.14] border border-white/20 text-white font-semibold text-sm shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer"
            >
              <Compass className="w-4 h-4 text-[#5ab4ff]" />
              <span>All Calculators</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
